import "./Footer.css";
import { Link } from "react-router";

function Footer() {
  return (
    <footer className="footer dark-bg">
      <div className="zone">
        <div className="footer-content">
          <div className="footer-content-item  text-align-left">
            <Link to="/login">Investor Login</Link>
          </div>
          <div className="footer-content-item  text-align-right">© 2024 All rights reserved</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
